module.exports = __webpack_public_path__ + "img/image52.0720ffd2.png";